/**
 * Base map is a copy of Gitlab map component
 * Created by Pavel Kozhin on 13/05/16.
 */

define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object'],
  function($, _, Object) {

    /**
     * Constructor for MapPoint.
     *
     * This entity is used to encapsulate data related to the
     * point on a map including marker and geo coordinates.
     *
     * The important thing is to get 'mapPoints' array via options
     * to be able to render markers and have map properly positioned.
     * The single map point is an object which has 2 mandatory fields:
     * 'lat' (latitude) and 'lon' (longitude).
     *
     * @param data
     * @constructor
     */
    var MapPoint = function(data)
    {
      if (!(data.lat && data.lon && parseFloat(data.lat) !== NaN && parseFloat(data.lon) !== NaN)) {
        throw new Error("MapPoint coordinates are invalid.");
      }
      this.marker = null;
      this.latlng = new google.maps.LatLng(parseFloat(data.lat), parseFloat(data.lon));
    };

    /**
     * Constructor of Map component.
     *
     * @param element An jQuery selector.
     * @param options An options for initialization.
     * @constructor
     */
    var Map = function(element, options)
    {
      if (!((element instanceof $) && element.length)) {
        throw new Error("Map parameters are malformed.");
      }
      if (!(google && google.maps)) {
        throw new Error("GoogleMaps API is not available.");
      }

      var defaultOptions = {
        'mapOptions': {
          'zoom': 11,
          'panControl': false,
          'zoomControl' : true,
          'zoomControlOptions': {style: google.maps.ZoomControlStyle.SMALL},
          'mapTypeControl':true,
          'scaleControl':false,
          'streetViewControl':false,
          'overviewMapControl':true,
          'overviewMapControlOptions': {opened: true},
          'rotateControl':false,
          'mapTypeId': google.maps.MapTypeId.ROADMAP
        },
        /* Should be an array of objects with geo coordinates
         e.g. {lat:123456, lon:123456} */
        mapPoints: [],
        pinchZoomDisabled: false
      };

      this.isCreated = false;

      this._map = null;
      this._mapElement = null;
      this._element = element;
      this._options = $.extend({}, defaultOptions, options || {});

      this._init();
    };

    Map.prototype =
    {
      /**
       * Create a GoogleMap instance.
       */
      create: function()
      {
        var bounds, mapOptions = this._options.mapOptions;

        if (!this._map) {
          this._map = new google.maps.Map(this._mapElement.get(0), mapOptions);
          bounds = new google.maps.LatLngBounds();

          _.each(this._mapPoints, function(mapPoint) {
            bounds.extend(mapPoint.latlng);
          });

          this._applyMapBounds(bounds);
          this._updateMarkers(this._mapPoints);
          this.isCreated = true;
        }
      },

      /**
       * This method updates map with new map points raw data.
       *
       * @param {array} items An array of map points data,
       *      map points should have at lest 'lat' and 'lon'
       *      properties indicating geo location coordinates.
       */
      update: function(items)
      {
        if (!this._map) {
          throw new Error("Map should be created. Use create() method first.");
        }
        var newMapPoints = this._createMapPoints(items);

        this._updateMarkers(newMapPoints);
        this._mapPoints = newMapPoints;

      },

      /**
       * Initializes map component
       * @private
       */
      _init: function()
      {
        this._mapElement = this._element;
        this._mapPoints = this._createMapPoints(this._options.mapPoints);

        // Disable pinch zoom on map element
        if (this._options.pinchZoomDisabled){
          $(this._mapElement)[0].addEventListener('touchmove', this._preventPinchZoom, true);
        }
      },

      /**
       * Prevents a pinch zoom event
       * @param jQuery.Event
       * @returns {boolean}
       * @private
       */
      _preventPinchZoom: function (e) {
        if (e.touches.length > 1) {
          e.preventDefault();
        }

        return false;
      },

      /**
       * This method removes old markers and create the new ones
       * (if passed).
       *
       * @param {array} mapPoints An array of MapPoint instances.
       * @private
       */
      _updateMarkers: function(mapPoints)
      {
        if (!this._map) { return; }

        var self = this;

        _.each(this._mapPoints, function(mapPoint) {
          if (mapPoint.marker) {
            mapPoint.marker.setMap(null);
          }
        });

        if (mapPoints) {
          _.each(mapPoints, function(mapPoint) {
            mapPoint.marker = new google.maps.Marker({
              position: mapPoint.latlng,
              map: self._map
            });
          });
        }
      },

      /**
       * This method converts map points raw data to MapPoint
       * internal instances.
       *
       * @private
       * @param {array} items An array of map points data,
       *      map points should have at lest 'lat' and 'lon'
       *      properties indicating geo location coordinates.
       * @return {array} An array of MapPoint instances
       *      or empty array.
       */
      _createMapPoints: function(items)
      {
        var result = [], self = this;

        if (_.isArray(items)) {
          _.each(items, function(item) {
            result.push(new MapPoint(item));
          });
        }
        return result;
      },

      /**
       * This method applies bounds, centering and zoom to
       * the GoogleMap instance.
       *
       * @private
       * @param {google.maps.LatLngBounds} bounds
       */
      _applyMapBounds: function(bounds)
      {
        if (!this._map) { return; }

        var center = bounds.getCenter(), c = 0.1,
          sw = new google.maps.LatLng(center.lat() + c, center.lng() - c),
          ne = new google.maps.LatLng(center.lat() - c, center.lng() + c);

        bounds.extend(sw);
        bounds.extend(ne);

        this._map.setCenter(bounds.getCenter());
        this._map.setZoom(this._options.mapOptions.zoom);
        this._map.fitBounds(bounds);
      }
    };

    return Map;
  }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/map/baseMap.js